'use strict';
import Common from '../../Utils/Common';

/**
 * @classname NotReceivableShop
 * @classdesc 受取店舗不可エラー表示
 */
export default class NotReceivableShop {
	/**
	 * @constructor
	 * @param {jQuery} $e - #not_receivable_shop
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		if($e.val() === '1') this.showError();
	};


	/**
	 * エラー表示
	 *
	 * @memberof NotReceivableShop
	 * @return undefined
	 */
	showError() {
		console.log(`${this.constructor.name}.showError`);
		Common.showErrorModal('指定した店舗では商品を受け取ることができません。');
		$('#nav-favorite-tab').click();
	};
};
